import { ReactNode } from "react";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** Section label/title */
  label: string;
  /** Section content */
  children: ReactNode;
  /** Gap between items (default: 1 = gap-1) */
  gap?: 1 | 2 | 4;
  /** Test ID */
  "data-testid"?: string;
};

const gapClasses = {
  1: "gap-1",
  2: "gap-2",
  4: "gap-4",
} as const;

/**
 * Profile section with a bold label and content.
 * Used for displaying profile information in a consistent format.
 */
export function ProfileSection({
  label,
  children,
  gap = 1,
  "data-testid": testId,
}: Props) {
  return (
    <div className={`flex flex-col ${gapClasses[gap]}`} data-testid={testId}>
      <Type variant="h5">
        {label}
      </Type>
      {children}
    </div>
  );
}

export default ProfileSection;
